<template>
  <div class="iao-list" :class="borderless ? 'borderless' : ''">
    <div class="iao-header">
      <slot name="title">
        <div class="iao-title">
          <a-icon class="iao-icon" type="pic-center" />
          <span>{{ title }}</span>
        </div>
      </slot>
      <slot name="extra"></slot>
    </div>
    <div class="iao-body">
      <slot name="body">
        <a-list class="iao-bodycontent" :dataSource="dataList" :pagination="pagination">
          <a-list-item slot="renderItem" slot-scope="item">
            <div class="iao-list-item">
              <div class="iao-list-item-body">
                <div class="iao-bodycontent-wrapper">header</div>
                <div class="iao-workflow-wrapper">
                  <div class="title-wrap"></div>
                  <a-timeline class="m-timeline-content">
                    <a-timeline-item
                      v-for="(timeline, index) in item.timeline"
                      :key="index"
                      class="m-display-flex space-between flex-row nowrap"
                    >
                      <span class="margin-right">{{timeline.actor}}</span>
                      <status :class="isMobile ? 'margin-remove' : ''" :status="timeline.status" />
                    </a-timeline-item>
                  </a-timeline>
                </div>
              </div>
              <div class="iao-list-item-footer">footer</div>
            </div>
          </a-list-item>
        </a-list>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    borderless: {
      default: false,
      type: Boolean,
    },
    isMobile: {
      default: false,
      type: Boolean,
    },
    title: String,
    dataList: {
      type: Array,
      required: true,
    },
  },
  name: "IaoList",
  data() {
    return {
      pagination: {
        pageSize: 5,
      },
    };
  },
};
</script>

<style lang="less" scoped>
.iao {
  &-list {
    background-color: white;
    border: 1px solid darken(white, 5);
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    &-item {
      background-color: white;
      display: flex;
      flex-direction: column;
      flex: 1;
      &-body {
        display: flex;
        justify-content: space-between;
        padding: 12px;
      }
      &-footer {
        padding: 0 12px;
        background-color: white;
        border-top: 1px solid darken(white, 5);
        min-height: 40px;
        display: flex;
        align-items: center;
      }
    }
  }
  &-header {
    display: flex;
    justify-content: space-between;
    min-height: 50px;
    padding: 12px;
    align-items: center;
    border-bottom: 1px solid darken(white, 5);
  }
  &-title {
    color: @color-secondary;
    font-weight: 600;
    font-size: 1.1em;
  }
  &-body,
  &-bodycontent {
    overflow: auto;
    flex: 1;
    &-wrapper {
      flex: 1;
    }
  }
  &-bodycontent {
    background-color: whitesmoke;
  }
  &-workflow {
    &-wrapper {
      height: 100%;
      padding: 12px;
      background-color: whitesmoke;
      border: 1px solid darken(white, 5);
      width: 40%;
    }
  }
  &-icon {
    margin-right: 4px;
  }
}
.ant-list {
  //   &-pagination {
  //     background-color: white;
  //     margin: 0 !important;
  //     padding: 12px !important;
  //   }
  &-item {
    padding: 0;
    margin-bottom: 6px;
  }
}
.borderless {
  border: unset;
}
</style>